import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { cubicBezier, calcCoordinatesFromAngle, Gauge } from 'gauge-chart-js';

const gradstop = require('gradstop');

const FROM_ANGLE = 220;
const TO_ANGLE = 500
const MAX_VALUE = TO_ANGLE - FROM_ANGLE;

@Component({
  selector: 'app-margin-ratio',
  templateUrl: './margin-ratio.component.html',
  styleUrls: ['./margin-ratio.component.scss']
})
export class MarginRatioComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() pool = false;
  @Input() value: number;

  @ViewChild('gauge') private gauge: ElementRef;

  private gaugeBackground: Gauge;
  private gaugeMain: Gauge;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.setValue(this.value);
  }

  ngAfterViewInit() {
    this.gaugeBackground = new Gauge({
      lineWidth: 4,
      container: this.gauge.nativeElement,
      fromAngle: FROM_ANGLE,
      toAngle: TO_ANGLE,
      animationDuration: 0,
      color: '#2D3639'
    });
    this.gaugeBackground.setValue(MAX_VALUE).then(() => {
      this.addLabel('.50', 0.50 / 3);
      this.addLabel('.80', 0.80 / 3, 'indicator-pool');
      this.addLabel('1', 1 / 3);
    });

    this.gaugeMain = new Gauge({
      lineWidth: 4,
      container: this.gauge.nativeElement,
      fromAngle: FROM_ANGLE,
      toAngle: TO_ANGLE,
      easing: cubicBezier(0.165, 0.84, 0.44, 1),
      colors: gradstop({
        stops: MAX_VALUE,
        colorArray: ['#E4012A', '#F7E15C', '#4BEA94']
      })
    });
    this.setValue(this.value);
  }

  private setValue(value: number) {
    value = value || 0;
    if (this.gaugeMain) {
      this.gaugeMain.setValue(Math.floor(Math.min(value, 3) / 3 * MAX_VALUE));
    }
  }

  private addLabel(label: string, percent: number, className = '') {
    const offset = this.gauge.nativeElement.clientWidth / 10 + Math.max(label.length - 1, 0) * 5;
    const { metadata } = this.gaugeBackground.getElementAtValue(Math.floor(percent * MAX_VALUE));
    const { x, y } = calcCoordinatesFromAngle(offset, metadata.angle);
    const left = `${(metadata.relativeLeft + x) / this.gauge.nativeElement.clientWidth * 100}%`;
    const top = `${(metadata.relativeTop + y) / this.gauge.nativeElement.clientHeight * 100}%`;
    const html = `<span class="indicator ${className}" style="left: ${left}; top: ${top};">${label}</span>`;
    this.gaugeBackground.insertAdjacentToRoot('beforeend', html);
  }
}
